module.exports = __webpack_public_path__ + "static/media/GOI_L.c3a7731d.png";